
const dhurika="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/devteam/dhurika.webp"
const stalin="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/devteam/stalin.webp"
const kaviya="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/devteam/kaviya.webp"
const belcy="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/devteam/belcy.webp"
const harish="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/devteam/harish.webp"
const arjun="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/devteam/arjun.webp"
const sathiyan="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/devteam/sathiyan.webp"
const mohana="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/devteam/Mohana.webp"
const kani="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/devteam/kani.webp"
const sriram="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/devteam/sriram.webp"
const gopi="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/devteam/Gopi.webp"
const chandraprabha ="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/devteam/kcp.webp"
const alakesh ="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/devteam/Alakesh.webp"
const pavitha="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/devteam/Pavitha.webp"
const madasamy ="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/devteam/Madasamy.webp"
const visali ="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/devteam/Visali.webp"
const kishor ="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/devteam/kishor.webp"
const lawrance="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/devteam/lawrance.webp"
const mahalakshmi="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/devteam/Maha+Lakshmi.webp"
const srimathi="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/devteam/srimathi+(1).webp"

export const batch_2025=[
    {
        id:"1",
        name:"Arjun Prakash AS",
        batch:"2021-2025 Batch",
        linkedin:"https://www.linkedin.com/in/arjun-prakash-sivakumar-ab1872240",
        pic:arjun,
        color:"#ffc400"
    },
    
    {
        id:"2",
        name:"Arockiya Belcy VS",
        batch:"2021-2025 Batch",
        linkedin:"http://www.linkedin.com/in/arockiya-belcy-vs",
        pic:belcy,
        color:"#ffc400"
    },

    
    {
        id:"3",
        name:"Harish I",
        batch:"2021-2025 Batch",
        linkedin:"https://www.linkedin.com/in/harish-i-216000247/",
        pic:harish,
        color:"#ffc400"
    },
    {
        id:"4",
        name:"Kaviya B",
        batch:"2021-2025 Batch",
        linkedin:"https://www.linkedin.com/in/kaviya-b-6270b9247",
        pic:kaviya,
        color:"#ffc400"
    },
    {
        id:"5",
        name:"Sathiyan R",
        batch:"2021-2025 Batch",
        linkedin:"https://www.linkedin.com/in/sathiyan-r/",
        pic:sathiyan,
        color:"#ffc400"
    },
]
 export const batch_2026=[
    {
        id:"6",
        name:"Gopinath S",
        batch:"2022-2026 Batch",
        linkedin:"http://www.linkedin.com/in/gopinath-s01",
        pic:gopi,
        color:"#69d2ffff"
    },
    {
        id:"7",
        name:"Kanishka M",
        batch:"2022-2026 Batch",
        linkedin:"https://www.linkedin.com/in/kanishka-m-5655472a0",
        pic:kani,
        color:"#69d2ffff"
    },
    {
        id:"8",
        name:"Mohanamala J ",
        batch:"2022-2026 Batch",
        linkedin:"https://www.linkedin.com/in/mohana-mala-025a88245",
        pic:mohana,
        color:"#69d2ffff"
    },
    {
        id:"9",
        name:"Sriram K",
        batch:"2022-2026 Batch",
        linkedin:"https://www.linkedin.com/in/sri-ram-1459192a2",
        pic:sriram,
        color:"#69d2ffff"
    },
 ]

 export const batch_2027=[
    {
        id:"11",
        name:"Alakeshvarkumar R",
        batch:"2023-2027 Batch",
        linkedin:"https://www.linkedin.com/in/alakeshvarkumar",
        pic:alakesh,
        color:"#61f300ff"
    },
    {
        id:"10",
        name:"Madasamy I",
        batch:"2023-2027 Batch",
        linkedin:"https://www.linkedin.com/in/madasamyi",
        pic:madasamy,
        color:"#61f300ff"
    },
    {
        id:"13",
        name:"Pavitha M",
        batch:"2023-2027 Batch",
        linkedin:"https://www.linkedin.com/in/pavitha-m-b821b8289",
        pic:pavitha,
        color:"#61f300ff"
    },
    
    {
        id:"12",
        name:"Visali E",
        batch:"2023-2027 Batch",
        linkedin:"https://www.linkedin.com/in/visali-elangovan-563608294",
        pic:visali,
        color:"#61f300ff"
    },
 ]
export const batch_2028=[
    {
        id:"13",
        name:"Kishor M",
        batch:"2024-2028 Batch",
        linkedin:"https://www.linkedin.com/in/kishor-manisekaran-95432527a",
        pic:kishor,
        color:"#f97316"
    },
    {
        id:"14",
        name:"Lawrance A",
        batch:"2024-2028 Batch",
        linkedin:"https://www.linkedin.com/in/lawrance-a-78b213397",
        pic:lawrance,
        color:"#f97316"
    },
    {
        id:"15",
        name:"Maha Lakshmi S",
        batch:"2024-2028 Batch",
        linkedin:"https://www.linkedin.com/in/maha-lakshmi",
        pic:mahalakshmi,
        color:"#f97316"
    },
    
    {
        id:"16",
        name:"Srimathi G",
        batch:"2024-2028 Batch",
        linkedin:"https://www.linkedin.com/in/srimathi-g-7b50b4357",
        pic:srimathi,
        color:"#f97316"
    },
 ]


export const guide_team=[
    {
        id:"1",
        name:"Dhurika V",
        batch:"2020-2024 Batch",
        linkedin:"https://www.linkedin.com/in/dhurika-vijay-anand/",
        pic:dhurika,
        color:"#cc66ff"
    },
    {
        id:"2",
        name:"Barath Stalin K",
        batch:"2020-2024 Batch",
        linkedin:"https://www.linkedin.com/in/barathstalin/",
        pic:stalin,
        color:"#cc66ff"
    },
]
export const staff_incharge=[

    {
        id:"1",
        name:"K.Chandraprabha",
        batch:"Associate professor/CSE",
        linkedin:"https://www.linkedin.com/in/chandra-prabha-12860423/",
        pic:chandraprabha,
        color:"#0099ff"
    },

]